import {useEffect, useRef, useState} from "react";

const RowTRComponent = ({
                            fieldName,
                            _TC,
                            valueIn,
                            deactivated = null,
                            type = "text",
                            inputProps = {},
                        }) => {
    const [value, setValue] = useState("");
    const last = useRef(null);


    useEffect(() => {
        setValue(valueIn);
        last.current = valueIn;
    }, [valueIn]);

    const handleHexInput = (e) => {
        const input = e.target.value.toUpperCase();

        // Permitir campo vacío
        if (input === "") {
            setValue("00");
            return;
        }

        // Validar que solo contenga caracteres hexadecimales (0-9, A-F)
        const hexRegex = /^[0-9A-F]{0,2}$/;

        if (hexRegex.test(input)) {
            setValue(input);
        }
    };

    return (
        <tr>
            <td>{_TC(fieldName)}</td>
            <td>{_TC(`${fieldName}.description`)}</td>
            <td className="text-end">
                <label htmlFor={fieldName} className="form-label mb-0">
                    {_TC(fieldName)}
                </label>
            </td>
            <td style={{width: "60px"}}>
                <input
                    type={type}
                    id={fieldName}
                    name={fieldName}
                    className="form-control text-end mb-0"
                    title={_TC(fieldName)}
                    value={value}
                    onChange={handleHexInput}
                    maxLength="2"
                    placeholder="00"
                    style={{maxWidth: "40px"}}
                    {...inputProps}
                />
            </td>
        </tr>
    );
};
export default RowTRComponent;
